<template>
  <button :class="{btn:true}" :style="{background:bgcolor,color:fcolor,width:btnsize}">
      <slot></slot>
  </button>
</template>

<script>
export default {
  props:{
    bgcolor:{
      type:String,
      default:""
    },
    fcolor:{
      type:String,
      default:"#fff"
    },
    btnsize:{
      type:String,
      default:"1.54rem"
    }
  }
};
</script>

<style scoped>
.btn {
  border: 0 none;
  padding: 0;
  margin: 0;
  outline-style: none;
  line-height: 56px;
  color: #ffffff;
  font-size: 20px;
  border-radius: 28px;
}
</style>
